function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component";
import { getImagePositionStyles } from "segments/desktop/core-components/images-grid/images-grid-service";
import DefaultProps from "./default-props";
import { StyledGridImage } from "./grid-image.scss";
class GridImage extends PureComponent {
    renderPicture() {
        const { src, alt, isDecorative, link, imageStyle } = this.props;
        const { href, isNewTab } = link;
        const target = isNewTab ? "_blank" : "_self";
        return /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
            src: src,
            alt: alt,
            isDecorative: isDecorative,
            className: "image",
            target: target,
            href: href,
            specificImageStyle: imageStyle
        });
    }
    render() {
        const { height, width, imagePosition } = this.props;
        const imagePositionStyles = getImagePositionStyles(imagePosition);
        return /*#__PURE__*/ _jsx(StyledGridImage, {
            className: "grid-image",
            style: _object_spread({
                height,
                width
            }, imagePositionStyles),
            children: this.renderPicture()
        });
    }
}
export { GridImage as default };
GridImage.defaultProps = DefaultProps;
